import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { getSourceStr, getStatusStr, SourceTypes, StatusUserTypes } from '../Frauds.constans';


const FraudsList = ({ fraudUsersList, loading }) => {

    const columns: GridColDef[] = [
        {
            field: 'id',
            headerName: 'Id ',
            width: 50,
        },
        {
            field: 'user_id',
            headerName: 'Id usuario',
            width: 100,
        },
        {
            field: 'user_email',
            headerName: 'Email de usuario',
            flex: 1,
        },
        {
            field: 'suspicious_user_date',
            headerName: 'Fecha que se agrego',
            width: 180,
        },
        {
            field: 'verified_user_date',
            headerName: 'Fecha de verificación',
            width: 180,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 180,
            renderCell: (params) => {
                const { status } = params.row;
                return <span>{getStatusStr[parseInt(status) as StatusUserTypes]}</span>;
            }
        },
        {
            field: 'source',
            headerName: 'Source',
            width: 100,
            flex: 1,
            renderCell: (params) => {
                const { source_id } = params.row;
                return <span>{getSourceStr[parseInt(source_id) as SourceTypes]}</span>;
            }
        },
    ];


    return (
        <DataGrid
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            rows={fraudUsersList}
            columns={columns}
            loading={loading}
            initialState={{
                pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                },
            }}
            pageSizeOptions={[5, 10, 25]}
            disableRowSelectionOnClick
            disableColumnFilter
            disableColumnMenu
            disableColumnSorting
            autoHeight
        />
    );
}


export default FraudsList;